import { Component, Input } from '@angular/core';
import { DataService } from '../../services/data.service';
import { first } from 'rxjs';
import { MenuStateService } from '../../services/menu-state.service';

@Component({
  selector: 'app-menu-modelos',
  standalone: false,
  templateUrl: './menu-modelos.component.html',
  styleUrl: './menu-modelos.component.css'
})
export class MenuModelosComponent {
  @Input() categoria:any;
  modelos:any[]=[];

  constructor(private vehiculosService: DataService, private menuStateService: MenuStateService){
    
  }
  ngOnInit(): void {
   const modelosGuardados = localStorage.getItem(this.categoria);
    
    if (modelosGuardados) {
      this.modelos = JSON.parse(modelosGuardados);
    } else {
      /*this.vehiculosService.getCategoriasModels().pipe(first()).subscribe(
        (data:any) => {
          this.modelos = data;
        }
      );*/
    }
  }
  formatKey(key: string): string {
    return key
      .replace(/-/g, ' '); // capitaliza cada palabra
  }
  cerrarMenu(): void {
    this.menuStateService.toggleMenu(false);
  }
}
